import * as tslib_1 from "tslib";
import { AudioManager } from "../managers/AudioManager";
import { AssetBase } from "../library/AssetBase";
// TODO: Audio should probably be an interface containing play/stop/seek functionality
var WaveAudio = (function (_super) {
    tslib_1.__extends(WaveAudio, _super);
    /**
     *
     */
    function WaveAudio(buffer) {
        var _this = _super.call(this) || this;
        _this._volume = 1;
        _this._pan = 0;
        _this._audioChannels = [];
        _this._buffer = buffer;
        return _this;
    }
    Object.defineProperty(WaveAudio.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return WaveAudio.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "pan", {
        get: function () {
            return this._pan;
        },
        set: function (value) {
            if (this._pan == value)
                return;
            this._pan = value;
            if (this._audioChannel)
                this._audioChannel.pan = this._pan;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "volume", {
        get: function () {
            return this._volume;
        },
        set: function (value) {
            if (this._volume == value)
                return;
            this._volume = value;
            if (this._audioChannel)
                this._audioChannel.volume = this._volume;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "currentTime", {
        get: function () {
            if (this._audioChannel)
                return this._audioChannel.currentTime;
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WaveAudio.prototype, "duration", {
        get: function () {
            if (this._audioChannel)
                return this._audioChannel.duration;
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    WaveAudio.prototype.dispose = function () {
        this.stop();
    };
    WaveAudio.prototype.play = function (offset, loop) {
        if (loop === void 0) { loop = false; }
        this._audioChannel = AudioManager.getChannel(this._buffer.byteLength);
        if (this._audioChannel) {
            this._audioChannels.push(this._audioChannel);
            this._audioChannel.volume = this._volume;
            this._audioChannel.play(this._buffer, offset, loop, this.id);
            if (this._onSoundComplete) {
                this._audioChannel.onSoundComplete = this._onSoundComplete;
            }
        }
    };
    Object.defineProperty(WaveAudio.prototype, "onSoundComplete", {
        set: function (value) {
            this._onSoundComplete = value;
            if (this._audioChannel) {
                this._audioChannel.onSoundComplete = this._onSoundComplete;
            }
        },
        enumerable: true,
        configurable: true
    });
    WaveAudio.prototype.stop = function () {
        for (var _i = 0, _a = this._audioChannels; _i < _a.length; _i++) {
            var channel = _a[_i];
            channel.stop();
        }
        this._audioChannels.length = 0;
        delete this._audioChannel;
        this._audioChannel = null;
    };
    WaveAudio.prototype.clone = function () {
        var newInstance = new WaveAudio(this._buffer);
        newInstance.name = this.name;
        return newInstance;
    };
    return WaveAudio;
}(AssetBase));
export { WaveAudio };
WaveAudio.assetType = "[asset WaveAudio]";



// WEBPACK FOOTER //
// ../dist/lib/audio/WaveAudio.js